<template>
  <CardPrimary :style="cardStyle">
    <div :style="userContainerStyle">
      <HybridLinkUserImagePrimary v-bind="userImageAttrs"
                                  :openInCurrentTab="false"
                                  :src="tenantUser.user.image"
                                  :tenantUserId="tenantUser.id" />
      <div :style="userNameContainerStyle">
        <HybridLinkNamePrimary :isRouterLink="false"
                               :style="linkNameStyle"
                               :tenantUserId="tenantUser.id"
                               :truncate="true">
          {{ tenantUser.user.firstName }} {{ tenantUser.user.lastName }}
        </HybridLinkNamePrimary>
        <div :style="customContentContainerStyle">
          <slot name="custom-content" />
        </div>
      </div>
    </div>
    <div :style="titleContainerStyle">
      <IconTextSecondary content="person_pin"
                         :truncate="true">
        {{ title }}
      </IconTextSecondary>
    </div>
    <div :style="locationContainerStyle">
      <IconTextSecondary content="location_on"
                         :truncate="true">
        {{ location }}
      </IconTextSecondary>
    </div>
  </CardPrimary>
</template>

<script>
  import CardPrimary from '@modules/card/card-primary'
  import HybridLinkNamePrimary from '@modules/link/hybrid-link-name-primary'
  import HybridLinkUserImagePrimary from '@modules/link/hybrid-link-user-image-primary'
  import IconTextSecondary from '@modules/text/icon-text-secondary'
  import { Layout } from '@js/styles'

  export default {
    name: 'SearchedUserMinimum',
    components: {
      CardPrimary,
      HybridLinkNamePrimary,
      HybridLinkUserImagePrimary,
      IconTextSecondary,
    },
    props: {
      tenantUser: { type: Object, required: false, default: () => {} },
    },
    data: function () {
      return {
        cardStyle: {
          alignItems: 'center',
          display: 'flex',
          height: '64px',
          padding: Layout.space.md,
          width: '100%',
        },
        customContentContainerStyle: {
          padding: `0 0 0 ${Layout.space.xs}`,
          width: 'calc(100% - 32px)',
        },
        linkNameStyle: {
          height: '20px',
          padding: `0 0 0 ${Layout.space.sm}`,
        },
        locationContainerStyle: {
          alignItems: 'center',
          display: 'flex',
          height: '100%',
          width: '25%',
        },
        userContainerStyle: {
          alignItems: 'center',
          display: 'flex',
          height: '100%',
          width: '50%',
        },
        userNameContainerStyle: {
          alignItems: 'space-between',
          display: 'flex',
          flexDirection: 'column',
          height: '100%',
          justifyContent: 'center',
          width: 'calc(100% - 32px)',
        },
        titleContainerStyle: {
          alignItems: 'center',
          display: 'flex',
          height: '100%',
          width: '25%',
        },
        userImageAttrs: {
          height: '32px',
          width: '32px',
        },
      };
    },
    computed: {
      location: function () {
        const location = this.tenantUser.location;
        return (location != null && location.length > 0) ? location : 'N/A';
      },
      title: function () {
        const title = this.tenantUser.title;
        return (title != null && title.length > 0) ? title : 'N/A';
      },
    },
  };
</script>
